// extracted by css-extract-rspack-plugin
var _1 = "Zpv8T";
export { _1 as "appContainer" }
